<template>
  <segment-page></segment-page>
</template>

<script>
import SegmentPage from '@/modules/audiences/pages/SegmentPage'
export default {
  name: 'SegmentCreatePage',
  components: { SegmentPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentPageCreate.vue